import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* financialStatementChangeSent(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_REQUEST
    });

    const res = yield call(Http.patch, `financial-statements/${action.payload?.statementId}/send-status`, {
      ...action.payload
    });

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_SUCCESS
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res?.data?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchFinancialStatementChangeSent() {
  yield takeEvery(Constants.PAGE_FINANCIAL_STATEMENT_CHANGE_SENT_START, financialStatementChangeSent);
}
